export default "__VITE_ASSET__B00pi5yJ__"